import { useState } from "react"
import { Link } from "react-router-dom"
import Select from 'react-select'

/* form */
import Input from "../../../shared/components/form/input"
import selectStyles from "../../../shared/css/SelectStyle"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"

// Unidade é fixa por natureza do item (um botão sempre é "unidade", uma linha sempre é
// "cone", independente de quem vende) — diferente do Tecido, aqui não existe uma regra de
// compra por fornecedor pra resolver a unidade.
const UNIT_OPTIONS = [
    { selectName: "unit", value: "un", label: "Unidade" },
    { selectName: "unit", value: "m", label: "Metro" },
    { selectName: "unit", value: "cone", label: "Cone" },
]

function FormAviamento({ handleSubmit, aviamentoData, btnText, btCancelLink, btCancelAction, title }) {

    const [aviamento, setAviamento] = useState(aviamentoData || {})

    function handleChange(e) {
        setAviamento({ ...aviamento, [e.target.name]: e.target.value })
    }

    function handleSelectChange(selectedOption) {
        setAviamento({ ...aviamento, [selectedOption.selectName]: selectedOption })
    }

    function submit(e) {
        e.preventDefault()
        // Evita que o submit borbulhe (via árvore React, mesmo com o Modal via portal) e
        // acione também o onSubmit do formulário que abriu este como "cadastro rápido".
        e.stopPropagation()
        handleSubmit(aviamento)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Nome do Aviamento"
                            type="text"
                            name="name"
                            placeholder="digite o nome do aviamento"
                            handleOnChange={handleChange}
                            value={aviamento.name || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Unidade:</label>
                        <Select
                            options={UNIT_OPTIONS}
                            styles={selectStyles}
                            onChange={handleSelectChange}
                            value={aviamento.unit || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormAviamento
